module.exports = __webpack_public_path__ + "img/filter_on.8f2e4be7.svg";